import React from 'react'
import { observer } from 'mobx-react-lite'

import { Checkbox, TableCell } from '@material-ui/core'

import { MyRowWithTableProps } from '../../types/tableTypes'
import { MyProductOnlyColumnId } from '../../types/myProductColumnIds'
import { MyProductModel } from '../../server/mpsklad_core/Models/MyProductModel'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import clsx from 'clsx'

export const MyProductSelectCell =
  observer(
    ({
       row,
       isSelected,
       table: {isRowSelected, toggleRowSelection}
     }: MyRowWithTableProps<MyProductOnlyColumnId, MyProductModel>) =>
      <TableCell
        className={clsx('table-border', isSelected && 'selected_row')}
        padding="checkbox"
        onClick={() => toggleRowSelection(row)}
        style={{cursor: 'pointer'}}
      >
        <Checkbox
          checked={isRowSelected(row)}
          inputProps={{'aria-labelledby': makeMyProductRowId(row)}}
          icon={<CircleUnchecked/>}
          checkedIcon={<CircleCheckedFilled style={{color: '#3987cf'}}/>}
          style={{color: '#3987cf'}}
        />
      </TableCell>
  )

export const makeMyProductRowId =
  (product: MyProductModel) => `my-product-${product.id}`